import React from 'react'
import { Button } from '@driftt/tide-core-legacy'

import ConditionPreview from '../ConditionPreview'

import './style.styl'

const ConditionSet = ({ conditionSet: { conditions }, onAddConditionClick, isOnFreePlan }) => (
  <div className="playbook-condition-set">
    {conditions.map((id, index, arr) => {
      const lastIndex = arr.size - 1
      const conditionComponents = [<ConditionPreview key={id} id={id} />]
      if (index !== lastIndex) conditionComponents.push(<div className="playbook-condition-set-and-copy">and</div>)
      return conditionComponents
    })}
    <div className="playbook-targeting-display-add-condition-wrapper">
      <Button className="drift-button drift-button-secondary" onClick={!isOnFreePlan && onAddConditionClick} disabled={isOnFreePlan}>
        + Add Condition
      </Button>
    </div>
    <div className="playbook-condition-set-or-copy">or</div>
  </div>
)

export default ConditionSet



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ConditionSet/component.js